exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-22a5b0ee] .el-card__body{height:100%}.card__body--nopadding[data-v-22a5b0ee] .el-card__body{padding:10px}.el-dialog .el-card[data-v-22a5b0ee],[data-v-22a5b0ee] .el-card .el-card{border:1px solid var(--lineBorderColor)!important}.to-model-preview[data-v-22a5b0ee]{cursor:pointer}.model_message_wrap[data-v-22a5b0ee]{background-color:#f5f5f5!important;color:#000!important}.model_message_wrap[data-v-22a5b0ee] .el-checkbox__inner{border-color:#000!important}.modelTree-tree[data-v-22a5b0ee]{height:calc(100% - 84px)}", ""]);

// exports
